import { apiService } from './apiService';
import { BinGuidelineDto, OrgBinGuidelinesDto } from 'types/api.types';

interface CreateBinPayload {
  title: string;
  color: string;
  contrastColor: string;
}

interface UpdateBinPayload {
  title: string;
  color: string;
  contrastColor: string;
}

interface SetBinMaterialsPayload {
  materialIds: number[];
}

interface AddBinExceptionPayload {
  itemId: number;
  ruleType: 'include' | 'exclude';
}

export const getOrgBinGuidelines = async (orgId: number): Promise<OrgBinGuidelinesDto | null> => {
  try {
    return await apiService.get<OrgBinGuidelinesDto>(`/admin/organizations/${orgId}/bin-guidelines`);
  } catch (error) {
    return null;
  }
};

export const createBinGuideline = async (
  orgId: number,
  payload: CreateBinPayload,
): Promise<BinGuidelineDto | null> => {
  try {
    return await apiService.post<BinGuidelineDto>(
      `/admin/organizations/${orgId}/bin-guidelines/bins`,
      payload,
    );
  } catch (error) {
    return null;
  }
};

export const updateBinGuideline = async (
  orgId: number,
  binId: number,
  payload: UpdateBinPayload,
): Promise<BinGuidelineDto | null> => {
  try {
    return await apiService.put<BinGuidelineDto>(
      `/admin/organizations/${orgId}/bin-guidelines/bins/${binId}`,
      payload,
    );
  } catch (error) {
    return null;
  }
};

export const setBinGuidelineMaterials = async (
  orgId: number,
  binId: number,
  payload: SetBinMaterialsPayload,
): Promise<BinGuidelineDto | null> => {
  try {
    return await apiService.put<BinGuidelineDto>(
      `/admin/organizations/${orgId}/bin-guidelines/bins/${binId}/materials`,
      payload,
    );
  } catch (error) {
    return null;
  }
};

export const addBinGuidelineException = async (
  orgId: number,
  binId: number,
  payload: AddBinExceptionPayload,
): Promise<BinGuidelineDto | null> => {
  try {
    return await apiService.post<BinGuidelineDto>(
      `/admin/organizations/${orgId}/bin-guidelines/bins/${binId}/exceptions`,
      payload,
    );
  } catch (error) {
    return null;
  }
};

export const deleteBinGuideline = async (orgId: number, binId: number): Promise<boolean> => {
  try {
    await apiService.delete<void>(`/admin/organizations/${orgId}/bin-guidelines/bins/${binId}`);
    return true;
  } catch (error) {
    return false;
  }
};

export const deleteBinGuidelineException = async (
  orgId: number,
  binId: number,
  exceptionId: number,
): Promise<boolean> => {
  try {
    await apiService.delete<void>(
      `/admin/organizations/${orgId}/bin-guidelines/bins/${binId}/exceptions/${exceptionId}`,
    );
    return true;
  } catch (error) {
    return false;
  }
};
